import React from "react";
import styled from "styled-components";
import { displayPrice, normalizePriceAmount, Price } from "sweet-global";
import MoneyIcon from "sweet-web/components/icons/MoneyIcon";
import { ItemLabel, ItemTitle } from "sweet-web/components/universal/Text";
import { globalInputStyles, IconWrapper } from "./index";

const Wrapper = styled.div`
  padding: 10px 0 10px 0;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  ${globalInputStyles}
  width: 100%;
  padding-left: 35px;
`;

type Props = {
  title?: string;
  description?: string;
  value: Price;
  onChange: (value: Price) => void;
  onBlur?: () => void;
  style?: object;
};
const PriceInput: React.FC<Props> = props => {
  return (
    <Wrapper style={props.style}>
      {props.title && <ItemTitle>{props.title}</ItemTitle>}
      {props.description && <ItemLabel>{props.description}</ItemLabel>}
      <Input
        type="tel"
        inputMode="numeric"
        key={"number-input"}
        id={"number-input"}
        value={props.value && props.value.amount ? props.value.amount : ""}
        onChange={e => {
          props.onChange({
            currency: "USD",
            amount: Number(e.target.value)
          });
        }}
        onBlur={props.onBlur}
      />
      <IconWrapper>
        <MoneyIcon size={14} />
      </IconWrapper>
    </Wrapper>
  );
};
PriceInput.defaultProps = {
  title: "Phone Number",
  onBlur: () => {},
  style: {}
};

export default PriceInput;
